import { render, staticRenderFns } from "./PageDebtors.vue?vue&type=template&id=f75a7a5e"
import script from "./PageDebtors.vue?vue&type=script&lang=js"
export * from "./PageDebtors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports